module.exports = __webpack_public_path__ + "img/icon1.ad9aac00.png";